import React, { useState, useEffect } from "react";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";
import { StyledForm } from "../../styled-components/StyledForm.style";
import { StyledPartialSinistroTimeSheetsPage } from "../../styled-components/StyledPartialSinistroTimeSheetsPage.style";
import api from '../../services/api';
import Swal from "sweetalert2";

export const ModalAprovacoesVincular = ({
    isOpen,
    setIsOpen,
    onSuccess,
    pendenciaDeAprovacao
}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [timesheet, setTimesheet] = useState([]);
    const [idsSelecionados, setIdsSelecionados] = useState([]);
    const [idsSelecionadosParaDesvincular, setIdsSelecionadosParaDesvincular] = useState([]);

    const onAfterOpen = () => { };

    const closeModal = () => {
        setIsOpen(false);
        setIdsSelecionados([]);
        setIdsSelecionadosParaDesvincular([]);
    }

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '60%',
            maxWidth: '80%',
            overflowY: 'auto',
            minHeight: '45%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        }
    }

    const getTimesheetById = async () => {
        setIsLoading(true);
        console.log("pendenciaDeAprovacao", pendenciaDeAprovacao);
        try {
            const response = await api.get(`Timesheet/vincular/${pendenciaDeAprovacao.idTimesheet}`, config);
            const data = response.data.data;
            setTimesheet(data);
            
            let idsIniciais = [pendenciaDeAprovacao.idTimesheet];

            const idsJaVinculados = data
                .filter(tsItem => tsItem.vinculado === true)
                .map(tsItem => tsItem.idTimesheet);

            const isEdicao = idsJaVinculados.length > 0;

            idsIniciais = [...idsIniciais, ...idsJaVinculados];

            if (!isEdicao) {
                const isIndicacao = data.some(tsItem => tsItem.indicacao === true);

                if (isIndicacao) {
                    const idsVinculaveis = data
                        .filter(tsItem => tsItem.podeVincular)
                        .map(tsItem => tsItem.idTimesheet);
                    
                    idsIniciais = [...idsIniciais, ...idsVinculaveis];
                }
            }

            setIdsSelecionados(Array.from(new Set(idsIniciais)));
        } catch (err) {
            console.error("Error fetching timesheet:", err);
        } finally {
            setIsLoading(false);
        }
        return "Error";
    }

    const formatCurrency = (value) => {
        if (!value) {
            return 'R$ 0,00';
        }

        return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 });
    };

    const formatDecimal = (value) => {
        if (value == null || value === undefined || value === 0) {
            return '0,00';

        }
        return value.toLocaleString('pt-br', { style: 'decimal', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });

    };

    const handleCheckboxChange = (tsItem) => {
        const id = tsItem.idTimesheet;
        const isAtualmenteSelecionado = idsSelecionados.includes(id);

        if (isAtualmenteSelecionado) {
            setIdsSelecionados((prev) => prev.filter(item => item !== id));
            
            if (tsItem.vinculado) {
                setIdsSelecionadosParaDesvincular((prev) => 
                    !prev.includes(id) ? [...prev, id] : prev
                );
            }
        } else {
            setIdsSelecionados((prev) => [...prev, id]);
            if (tsItem.vinculado) {
                setIdsSelecionadosParaDesvincular((prev) => prev.filter(item => item !== id));
            }
        }
    };

    const acaoVincular = async () => {
        if (idsSelecionados.length <= 1 && idsSelecionadosParaDesvincular <= 0) {
            Swal.fire({
                html: "Por favor, selecione ao menos um outro Timesheet para vincular.",
                icon: "warning",
                confirmButtonText: "Ok"
            });
            return;
        }

        Swal.fire({
            html: `Deseja Vincular este Timesheet?`,
            icon: "info",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then(async (result) => {
            if (result.isConfirmed) {
                Swal.showLoading();
                try {
                    const data = {
                        IdTimesheet: pendenciaDeAprovacao.idTimesheet,
                        IdPendenciaAprovacao: pendenciaDeAprovacao?.idPendenciaAprovacao,
                        IdTimesheetsVincular: idsSelecionados,
                        IdTimesheetsDesvincular: idsSelecionadosParaDesvincular
                    };
                    const response = await api.put(`Timesheet/vincular`, data, config);
                    Swal.fire({
                        html: `Timesheet vinculado com sucesso!`,
                        icon: "success",
                        timer: 2000,
                        timerProgressBar: true,
                        showConfirmButton: false,
                        showCancelButton: false,
                    }).then((result) => {
                        if (onSuccess) {
                            onSuccess(); 
                        }
                        closeModal();
                    });
                } catch (err) {
                    Swal.fire({
                        html: `Erro ao vincular Timesheet!`,
                        icon: "error",
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: "Ok",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            closeModal();
                        }
                    });
                }
            }
        });
    }

    useEffect(() => {
        if (isOpen) {
            console.log("pendenciaDeAprovacao", pendenciaDeAprovacao);
            setIdsSelecionados([]);
            setIdsSelecionadosParaDesvincular([]);
            setTimesheet([]);
            
            getTimesheetById();
        }
    }, [isOpen, pendenciaDeAprovacao]);

    return (
    <Modal
        isOpen={isOpen}
        onAfterOpen={onAfterOpen}
        onRequestClose={closeModal}
        contentLabel="Aprovações Vincular"
        style={style}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={false}
    >

        <StyledForm>
            <Flex>
                <Flex.Item className="modal-width">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="pull-left">
                            <p className="modal-title"><i className="fa fa-link me-2" style={{ fontSize: '20px' }}></i>Vincular Timesheet</p>
                        </div>
                        <div className="pull-right">
                            <p className="modal-close" onClick={closeModal}><button className="default-button-red-small px-2">X</button></p>
                        </div>
                    </div>
                </Flex.Item>
            </Flex>
        </StyledForm>
        <StyledForm>
            <StyledTablePage>
                <div className="row mb-2" style={{ fontSize: "14px" }}>
                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Sigla</span><br/>{ pendenciaDeAprovacao?.sigla || "-" }</div>
                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Segurado</span><br/>{ pendenciaDeAprovacao?.segurado?.seguradoNome || pendenciaDeAprovacao?.segurado || "-" }</div>
                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Aprovador/Reprovador</span><br/>{ pendenciaDeAprovacao?.nomeAprovador || "-" }</div>
                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Empresa</span><br/>{ pendenciaDeAprovacao?.nomeEmpresa || "-" }</div>
                </div>

                <div className="row mb-2" style={{ fontSize: "14px" }}>
                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Cliente</span><br/>{ pendenciaDeAprovacao?.cliente?.clienteNome || pendenciaDeAprovacao?.cliente || "-" }</div>
                    <div className="col-3 text-center"><span style={{ color: "#999" }}>Disciplina</span><br/>{ pendenciaDeAprovacao?.disciplina || pendenciaDeAprovacao?.nomeDisciplina || "-" }</div>
                    { (pendenciaDeAprovacao?.totalHorasProBono != '0,00' && !pendenciaDeAprovacao) && ( <><div className="col-3 text-center"><span style={{ color: "#999" }}>Horas Pro Bono</span><br/>{ pendenciaDeAprovacao?.totalHorasProBono || "-" }</div></> )}
                    { (pendenciaDeAprovacao?.totalValorProBono != 'R$ 0,00' && !pendenciaDeAprovacao) && ( <><div className="col-3 text-center"><span style={{ color: "#999" }}>Valor Pro Bono</span><br/>{ pendenciaDeAprovacao?.totalValorProBono || "-" }</div></> )}
                    
                </div>

                <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                <div className="table-responsive">
                    <table className="table table-sm mb-0">
                        <thead>
                            <tr className="table-light" style={{ position: 'sticky', top: 0, zIndex: 5, background: '#fff' }}>
                                <th colSpan={9}> Timesheets relacionados</th>
                            </tr>
                            <tr>
                                <th scope="col" className="text-center">#</th>
                                <th scope="col" className="text-center">Sigla</th>
                                <th scope="col" className="text-center">TimeSheet</th>
                                <th scope="col" className="text-center">Status</th>
                                <th scope="col" className="text-center">Etapa Aprovação</th>
                                <th scope="col" className="text-center">Horas P.B</th>
                                <th scope="col" className="text-center">Valor P.B</th>
                                <th scope="col" className="text-center">Total Horas</th>
                                <th scope="col" className="text-center">Valor Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                    <tr>
                                        <td colSpan={9} className="text-center py-4">
                                            <div className="text-center">
                                                <div className="text-items-center">
                                                    <div className="spinner-border ms-auto mt-2" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                                    <div className="mt-2">
                                                        <strong style={{ color: "#EE4B21" }}>Aguarde enquanto validamos as informações</strong>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ) : timesheet.length === 0 ? (
                                    <tr>
                                        <td colSpan={9} className="text-center py-4 text-muted">
                                            Nenhum timesheet encontrado.
                                        </td>
                                    </tr>
                                ) : (
                                    timesheet.map((tsItem) => {
                                    const isPrincipal = tsItem.idTimesheet === pendenciaDeAprovacao.idTimesheet;
                                    return (
                                        <tr key={tsItem.idTimesheet} className={isPrincipal ? "table-ts-principal-check" : ""} style={{ fontSize: '14px' }}>
                                            <td className="text-center">
                                                <input 
                                                    type="checkbox" 
                                                    checked={idsSelecionados.includes(tsItem.idTimesheet)} 
                                                    onChange={() => handleCheckboxChange(tsItem)}
                                                    
                                                    // 1. (isPrincipal && !tsItem.vinculado) -> Trava o pai na primeira vez (criação).
                                                    // 2. (!tsItem.vinculado && !tsItem.podeVincular) -> Trava os filhos que não podem ser vinculados.
                                                    // Se já estiver vinculado (tsItem.vinculado === true), as duas condições dão falso e ele fica liberado!
                                                    disabled={(isPrincipal && !tsItem.vinculado) || (!tsItem.vinculado && !tsItem.podeVincular)} 
                                                />
                                            </td>
                                            <td className="text-center">{tsItem.sigla}</td>
                                            <td className="text-center">{tsItem.timeSheetSigla}</td>
                                            <td className="text-center">{tsItem.statusTimeSheet}</td>
                                            <td className="text-center">{tsItem.etapaAprovacao}</td>
                                            <td className="text-center">{formatDecimal(tsItem.horasProBono)}</td>
                                            <td className="text-center">{formatCurrency(tsItem.valorProBono)}</td>

                                            <td className="text-center">{formatDecimal(tsItem.totalHorasFaturadas)}</td>
                                            <td className="text-center">{formatCurrency(tsItem.valorTotalFaturado)}</td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                <div className="text-center">
                    <button className={`btn mx-1 mt-2 btn-block default-button-red`} type="button" onClick={() => acaoVincular()}>Vincular</button>
                </div>
            </StyledTablePage>
        </StyledForm>
    </Modal>);
};
